/**
 * Single source of truth for the feature pills shown on unauthenticated
 * marketing surfaces (login, signup left panels). Edit this list and every
 * surface updates — there is no copy of the pills anywhere else in the app.
 *
 * Keep ordered by user-facing relevance, not alphabetic. Five is the visual
 * sweet spot — adding more wraps awkwardly inside the 420px panel.
 */
export const MARKETING_PILLARS: readonly string[] = [
  'Finance',
  'Payroll',
  'People',
  'Budgeting',
  'Consolidation',
] as const;
